/**
 * Module catalogue — keep in sync with BackEnd/services/modules.js
 * The single source of truth for module codes, display names, icons,
 * and indicative RRP (recommended retail price, GBP / month / company).
 *
 * Pricing is for display & estimation only — actual contracts may differ.
 */
export const PRICING_CURRENCY = 'GBP';

export const MODULE_CATALOG = [
  {
    code: 'core',
    name: 'Core',
    description: 'Invoices, Expenses, Approvals, AI/OCR, Vendors, Reports, VAT Claims, Reconciliation',
    icon: '📦',
    alwaysOn: true,
    priceMonthly: 199,
  },
  {
    code: 'budgets',
    name: 'Budgets',
    description: 'Budget dashboard, analytics, lines, GL ↔ Budget assignment',
    icon: '💰',
    priceMonthly: 79,
  },
  {
    code: 'integrations',
    name: 'Systems Integration',
    description: 'Xero, Dynamics BC, QuickBooks, SAP — finance sync & posting',
    icon: '🔌',
    priceMonthly: 99,
  },
  {
    code: 'projects',
    name: 'Project Budgets',
    description: 'Projects, project lines, project-based budget tracking',
    icon: '📊',
    priceMonthly: 59,
  },
  {
    code: 'contracts',
    name: 'Vendor Contracts',
    description: 'Vendor contracts, renewal scheduler, contract payment tracking',
    icon: '📄',
    comingSoon: true,
    priceMonthly: 49,
  },
  {
    code: 'scheduler',
    name: 'Scheduler & Automation',
    description: 'Automated task scheduling, notification rules, email alerts, and automation flows',
    icon: '⏰',
    priceMonthly: 49,
  },
  {
    code: 'purchase_orders',
    name: 'Purchase Orders',
    description: 'Full PO lifecycle: creation, approval chain, ERP sync (Dynamics BC + Xero), invoice matching, budget commitment tracking',
    icon: '🛒',
    priceMonthly: 79,
  },
  {
    code: 'teams',
    name: 'AI Assistant',
    description: 'Browser & Teams voice agent: approve invoices by voice, ask finance questions, AI standups. Includes Teams bot integration.',
    icon: '🤖',
    priceMonthly: 49,
  },
  {
    code: 'phone_agent',
    name: 'Phone AI Agent',
    description: 'Call a dedicated phone number to speak to your SpocoDoc AI agent — no browser or app required.',
    icon: '📞',
    comingSoon: true,
    priceMonthly: 79,
  },
];

export function formatPrice(amount, currency = PRICING_CURRENCY) {
  if (amount == null) return '—';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

export const MODULES_BY_CODE = Object.fromEntries(MODULE_CATALOG.map(m => [m.code, m]));
export const ALL_MODULE_CODES = MODULE_CATALOG.map(m => m.code);

export function getModule(code) {
  return MODULES_BY_CODE[code] || { code, name: code, description: '' };
}
